// extracted by css-extract-rspack-plugin
export default {"card":"ehj1f"};